export const TYPE_INPUT = 'input'
export const TYPE_INPUT_NUMBER = 'inputNumber'
export const TYPE_TEXTAREA = 'textarea'
export const TYPE_CHECKBOX = 'checkbox'
export const TYPE_CHECKBOX_GROUP = 'checkboxGroup'
export const TYPE_RADIO_GROUP = 'radioGroup'
export const TYPE_SELECT = 'select'
export const TYPE_SELECT2 = 'select2'
export const TYPE_MULTIPLESELECT2 = 'multipleSelect2'
export const TYPE_COLOR_PICKER = 'colorPicker'

export const TARGET_CLASS = 'class'
export const TARGET_DISABLED = 'disabled'

export default {
  TYPE_INPUT: TYPE_INPUT,
  TYPE_INPUT_NUMBER: TYPE_INPUT_NUMBER,
  TYPE_CHECKBOX: TYPE_CHECKBOX,
  TYPE_CHECKBOX_GROUP: TYPE_CHECKBOX_GROUP,
  TYPE_RADIO_GROUP: TYPE_RADIO_GROUP,
  TYPE_SELECT: TYPE_SELECT,
  TYPE_TEXTAREA: TYPE_TEXTAREA,
  TYPE_COLOR_PICKER: TYPE_COLOR_PICKER,
  map: [
    {
      'name': 'font',
      'tab': 1,
      'selectors': '*',
      'type': TYPE_CHECKBOX_GROUP,
      'target': TARGET_CLASS,
      'options': [
        { value: 'font-weight-bold', html: '<span style="font-weight: bolder !important">B</span>' },
        { value: 'font-italic', html: '<span style="font-style: italic !important">I</span>' },
        { value: 'text-uppercase', html: '<span style="text-transform: uppercase !important">U</span>' }
      ]
    },
    {
      'name': 'text-align',
      'label': 'Align',
      'tab': 1,
      'selectors': '*',
      'type': TYPE_RADIO_GROUP,
      'target': TARGET_CLASS,
      'options': [
        { value: null, html: '<i title="empty" class="fa fa-times"></i>' },
        { value: 'text-left', html: '<i class="pt-1 fa fa-align-left"></i>' },
        { value: 'text-center', html: '<i class="pt-1 fa fa-align-center"></i>' },
        { value: 'text-right', html: '<i class="pt-1 fa fa-align-right"></i>' },
        { value: 'text-justify', html: '<i class="pt-1 fa fa-align-justify"></i>' }
      ]
    },
    {
      'name': 'color',
      'tab': 1,
      'label': 'Color',
      'type': TYPE_COLOR_PICKER,
      'selectors': '*',
    },
    {
      'name': 'background-color',
      'tab': 1,
      'label': 'BG Color',
      'type': TYPE_COLOR_PICKER,
      'selectors': '*',
    },
    {
      'name': 'font-size',
      'tab': 1,
      'label': 'Font Size',
      'type': TYPE_INPUT,
      'selectors': '*',
    },
    {
      'name': 'style',
      'tab': 2,
      'label': 'Style',
      'selectors': {
        'class': ['btn']
      },
      'type': TYPE_SELECT,
      'target': TARGET_CLASS,
      'options': [
        { value: null, html: '<i title="empty" class="fa fa-times"></i>' },
        { value: 'btn-primary', html: 'primary' },
        { value: 'btn-secondary', html: 'secondary' },
        { value: 'btn-success', html: 'success' },
        { value: 'btn-info', html: 'info' },
        { value: 'btn-warning', html: 'warning' },
        { value: 'btn-danger', html: 'danger' },
        { value: 'btn-light', html: 'light' },
        { value: 'btn-dark', html: 'dark' },
        { value: 'btn-link', html: 'link' },
        { value: 'btn-outline-primary', html: 'outline-primary' },
        { value: 'btn-outline-secondary', html: 'outline-secondary' },
        { value: 'btn-outline-success', html: 'outline-success' },
        { value: 'btn-outline-info', html: 'outline-info' },
        { value: 'btn-outline-warning', html: 'outline-warning' },
        { value: 'btn-outline-danger', html: 'outline-danger' },
        { value: 'btn-outline-light', html: 'outline-light' },
        { value: 'btn-outline-dark', html: 'outline-dark' }
      ]
    },
    {
      'name': 'size',
      'tab': 2,
      'label': 'Size',
      'selectors': {
        'class': ['btn']
      },
      'type': TYPE_RADIO_GROUP,
      'target': TARGET_CLASS,
      'options': [
        { value: null, html: '<i title="empty" class="fa fa-times"></i>' },
        { value: 'btn-lg', html: 'L' },
        { value: 'btn-sm', html: 's' },
        { value: 'btn-block', html: 'Bl' }
      ]
    },
    {
      'name': 'float',
      'tab': 2,
      'label': 'Float',
      'type': TYPE_RADIO_GROUP,
      'target': TARGET_CLASS,
      'selectors': '*',
      'options': [
        { value: null, html: '<i title="empty" class="fa fa-times"></i>' },
        { value: 'float-left', html: '<i class="pt-1 fa fa-align-left"></i>' },
        { value: 'mx-auto', html: '<i title="mx-auto" class="pt-1 fa fa-align-center"></i>' },
        { value: 'float-right', html: '<i class="pt-1 fa fa-align-right"></i>'},
        { value: 'float-none', html: '<i title="float-none" class="fa fa-close"></i>' }
      ]
    },
    {
      'name': 'width',
      'tab': 1,
      'label': 'Width',
      'type': TYPE_INPUT,
      'selectors': '*',
      'append': 'px',
      'expand': [
        {
          'name': 'min-width',
          'label': 'Min width',
          'append': 'px',
          'selectors': '*',
          'type': TYPE_INPUT,
        },
        {
          'name': 'max-width',
          'label': 'Max width',
          'append': 'px',
          'selectors': '*',
          'type': TYPE_INPUT,
        },
      ]
    },
    {
      'name': 'height',
      'tab': 1,
      'label': 'Height',
      'type': TYPE_INPUT,
      'selectors': '*',
      'append': 'px',
      'expand': [
        {
          'name': 'min-height',
          'label': 'Min height',
          'append': 'px',
          'selectors': '*',
          'type': TYPE_INPUT,
        },
        {
          'name': 'max-height',
          'label': 'Max height',
          'append': 'px',
          'selectors': '*',
          'type': TYPE_INPUT,
        },
      ]
    },
    {
      'name': 'padding',
      'tab': 1,
      'label': 'Padding',
      'append': 'px',
      'type': TYPE_INPUT_NUMBER,
      'selectors': '*',
      'expand': [
        {
          'name': 'padding-top',
          'label': 'Top',
          'append': 'px',
          'selectors': '*',
          'type': TYPE_INPUT_NUMBER,
        },
        {
          'name': 'padding-right',
          'label': 'Right',
          'append': 'px',
          'selectors': '*',
          'type': TYPE_INPUT_NUMBER,
        },
        {
          'name': 'padding-bottom',
          'label': 'Bottom',
          'append': 'px',
          'selectors': '*',
          'type': TYPE_INPUT_NUMBER,
        },
        {
          'name': 'padding-left',
          'label': 'Left',
          'append': 'px',
          'selectors': '*',
          'type': TYPE_INPUT_NUMBER,
        }
      ]
    },
    {
      'name': 'margin',
      'tab': 1,
      'label': 'Margin',
      'append': 'px',
      'type': TYPE_INPUT_NUMBER,
      'selectors': '*',
      'expand': [
        {
          'name': 'margin-top',
          'label': 'Top',
          'append': 'px',
          'selectors': '*',
          'type': TYPE_INPUT_NUMBER,
        },
        {
          'name': 'margin-right',
          'label': 'Right',
          'append': 'px',
          'selectors': '*',
          'type': TYPE_INPUT_NUMBER,
        },
        {
          'name': 'margin-bottom',
          'label': 'Bottom',
          'append': 'px',
          'selectors': '*',
          'type': TYPE_INPUT_NUMBER,
        },
        {
          'name': 'margin-left',
          'label': 'Left',
          'append': 'px',
          'selectors': '*',
          'type': TYPE_INPUT_NUMBER,
        },
        {
          'name': 'mx-auto',
          'label': 'Margin auto Horizontal',
          'selectors': '*',
          'type': TYPE_CHECKBOX,
          'target': TARGET_CLASS
        },
      ]
    },
    {
      'name': 'disabled',
      'tab': 2,
      'label': 'Disabled',
      'type': TYPE_CHECKBOX,
      'target': TARGET_DISABLED,
      'selectors': {
        'class': ['btn']
      },
    },
    {
      'name': 'id',
      'tab': 2,
      'label': '# ID',
      'type': TYPE_INPUT,
      'target': 'id',
      'selectors': '*',
    },
    {
      'name': 'onclick',
      'tab': 3,
      'label': 'OnClick',
      'selectors': '*',
      'type': TYPE_TEXTAREA,
      'target': 'onclick',
    },
    {
      'name': 'onsubmit',
      'tab': 3,
      'label': 'OnSubmit',
      'selectors': {
        'tagname': ['FORM']
      },
      'type': TYPE_TEXTAREA,
      'target': 'onsubmit',
    }
  ],
  tabs: [
    {
      'id': 1,
      'label': 'Look'
    },
    {
      'id': 2,
      'label': 'Options'
    },
    {
      'id': 3,
      'label': 'JS'
    },
  ],
  actions: {
    /**
     * @param option = {selectors: {class: [], attr: [], id:[] ...}, target: TARGET_CLASS }
     * @param element pass here this.editorElement
     * @return boolean
     **/
    match (option, element) {
      try {
        //console.log({'optionsMap.actions.match(option, element)': [option, element]});
        if (option.selectors === '*') {
          return true
        }
        for (let selectorKey in option.selectors) {
          if (option.selectors.hasOwnProperty(selectorKey)) {
            for (let v of option.selectors[selectorKey]) {
              if (selectorKey === TARGET_CLASS) {
                if (element.classList.contains(v)) {
                  //console.log({'optionsMap.actions.match(option, element) RESULT': true});
                  return true
                }
              } else {
                if (element.getAttribute(option.target) === v || element.getAttribute(selectorKey) === v) {
                  //console.log({'optionsMap.actions.match(option, element) RESULT': true});
                  return true
                }
              }
            }
          }
        }
        //console.log({'optionsMap.actions.match(option, element) RESULT': false});
        return false
      } catch (e) {
        console.error(e)
        return false
      }
    },
    /**
     * @param option = {options: ['val1', 'val2', ...], target: TARGET_CLASS }
     * @param element pass here this.editorElement
     * @return string|null
     **/
    filter (option, element) {

      try {
        ////console.log({'optionsMap.actions.filter(option, element)': [option, element]});
        let filtered = null

        if (option.type === TYPE_INPUT_NUMBER || option.type === TYPE_COLOR_PICKER) {
          if(element.getAttribute('style') === null) {
            return null;
          }
          let style = window.getComputedStyle(element)
          ////console.log({'optionsMap.actions.filter(option, element) RESULT': style.getPropertyValue(option.name)});
          return style.getPropertyValue(option.name).split(option.append).join('')

        } else if (option.target === TARGET_CLASS) {

          filtered = option.options.filter(opt => element.classList.contains(opt.value)).map(function(elem){
            return elem.value;
          })
          if (filtered.length) {
            if(option.type === TYPE_CHECKBOX_GROUP) {
              return filtered
            } else {
              return filtered.join(" ")
            }
          }

        } else if(option.target) {
          return element.getAttribute(option.target)
        } else {
          if(element.getAttribute('style') === null) {
            return null;
          }
          let style = window.getComputedStyle(element),
              value = style.getPropertyValue(option.name)
          value = (!Number.isNaN(parseFloat(value)) && Number.isFinite(value)) ? value.split(option.append).join('') : value
          return value
        }

        //todo other targets
        ////console.log({'optionsMap.actions.filter(option, element) RESULT': (typeof filtered[0]!=='undefined')?filtered[0]:null});

      } catch (e) {
        console.error(e)
      }
      return null
    }
  },
  listeners: {
    /**
     * @param element pass here this.editorElement
     * @param option pass here optionsMap.options[0]
     * @param value inputs selected value
     * @param updateTemplate function
     * @return boolean
     */
    change (element, option, value, updateTemplate) {
      try {////console.log({'optionsMap.listeners.change(element, option, value)': [element, option, value]});
        if ($(element).length) {

          if (option.type === TYPE_INPUT_NUMBER || option.type === TYPE_COLOR_PICKER) {

            let result = value;
            if(option.hasOwnProperty('append')) {
              result += option.append;
            }
            element.style.setProperty(option.name, result)

          } else if (option.target === TARGET_CLASS) {
            if (option.options) {
              option.options.forEach(el => {
                $(element).removeClass(el.value)
              })
              $(element).addClass(value)
            } else {
              $(element).removeClass(option.name)
              if (value) {
                $(element).addClass(option.name)
              }
            }

          } else if(option.target) {

            $(element).attr(option.target, value)

          } else {

            value = (!Number.isNaN(parseFloat(value)) && Number.isFinite(value)) ? value + option.append : value
            element.style.setProperty(option.name, value)

          }
          //todo other targets
        }
        ////console.log({'optionsMap.listeners.change(element, option, value) RESULT': true});

      } catch (e) {
        console.error(e)
      }

      if (typeof updateTemplate === 'function') {
        updateTemplate()
      }
      return true
    }
  }
}
